import { connect } from "react-redux";
import _get from "lodash-es/get";

import { RootState } from "src/ipm-shared/store/model/reducers";
import * as actions from "src/bepaid/store/model/Fetch/actions";

import * as selectors from "src/bepaid/store/model/Fetch/selectors";

import View from "./View";

const mapStateToProps = (state: RootState) => ({
  getControl: (name: string, form: string) =>
    selectors.getControl(state, name, form),
  paymentSetting: selectors.getSchedulePaymentSetting(state),
  selectedPaymentDetail: selectors.getSelectedPaymentDetail(state),
  selectedScheduleDetail: selectors.getScheduleDetail(state),
  extraInfo: selectors.getExtraInfo(
    state,
    actions.ModalID.EDIT_PAYMENT_DETAIL_MODAL
  ),
  upcomingPayment: selectors.getUpcomingPayment(state)
});

const mapDispatchToProps = {
  setControl: actions.setControl,
  toggleModal: actions.toggleModal,
  selectSchedule: actions.selectSchedule,
  fetchDateConditions: actions.fetchDateConditions
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
